import { Testimonial } from '../types'

export const testimonials: Testimonial[] = [
  {
    quote:
      'We used to dread pool days because our kids would come out with red eyes and itchy skin. Since switching to Hydrosprings, it\u2019s like swimming in bottled water. No rashes, no chlorine smell \u2014 just peace of mind knowing it\u2019s safe for my family.',
    name: 'Jessica M.',
    location: 'Miami, FL',
  },
  {
    quote:
      'I did the research. Hydrosprings isn\u2019t hype \u2014 it\u2019s real technology backed by science. My pool now meets EPA water standards without a drop of chlorine.',
    name: 'David S.',
    location: 'San Diego, CA',
  },
  {
    quote:
      'I haven\u2019t touched a chemical bucket in months. The water is crystal clear, it practically runs itself, and I\u2019ve saved hundreds on maintenance.',
    name: 'Luis R.',
    location: 'Scottsdale, AZ',
  },
]
